<template>
  <GModal
    class="re-fetch-gib-detail-modal-wrapper"
    :value="isShow"
    @close="onClose"
  >
    <template #body>
      <GBox
        flex
        direction="column"
      >
        <GBox
          :mt="24"
          :mb="16"
        >
          <GText variant="subtitle-01">
            Bilgilendirme
          </GText>
        </GBox>

        <GBox :mb="24">
          <GText>
            Cari ünvanı, vergi dairesi ve fatura adresi değerleriniz otomatik güncellenecektir.
          </GText>
        </GBox>

        <div class="btn-wrapper">
          <GButton
            class="btn ok-button"
            fluid
            @click="onApprove"
          >
            Onayla
          </GButton>
          <GButton
            variant="secondary"
            class="btn cancel-button"
            fluid
            @click="onClose"
          >
            Vazgeç
          </GButton>
        </div>
      </GBox>
    </template>
  </GModal>
</template>

<script>
import GModal from '@trendyol-js/grace/core/GModal';
import GBox from '@trendyol-js/grace/core/GBox';
import GText from '@trendyol-js/grace/core/GText';
import GButton from '@trendyol-js/grace/core/GButton';

export default {
  name: 'ReFetchGibDetailModal',

  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    GModal,
    GBox,
    GText,
    GButton,
  },

  methods: {
    onClose () {
      this.$emit('close');
    },
    onApprove () {
      this.$emit('submit');
    },
  },

};
</script>

<style lang="scss" scoped>
.re-fetch-gib-detail-modal-wrapper {
  ::v-deep .g-modal-mask {
    z-index: 1010;
  }
  ::v-deep .g-modal-wrapper {
    z-index: 1020;
  }
  ::v-deep .g-modal-container {
    max-width: 594px;

    .g-modal-header {
      position: absolute;
      top: 25px;
      right: 25px;

      svg {
        stroke: #273142;
      }
    }

    .g-modal-body {
      margin-top: 0 !important;
    }

    .g-text {
      text-align: center;
      line-height: 18px;
    }

    .cancel-button {
      margin-left: 30px;
    }

    .btn-wrapper {
      display: flex;
    }
  }

  @media only screen and (max-width:640px) {
    .btn-wrapper {
      flex-direction: column;

      .cancel-button {
        margin-left: 0;
        margin-top: 10px;
      }
    }
  }
}
</style>
